import { DateTime } from 'luxon'

import { MeetingOverview } from '@modules/contacts/types'

export const months = Array.from({ length: 12 }, (_, i) => {
  const date = DateTime.fromObject({ month: i + 1 })

  return { label: date.toFormat('MMM').charAt(0), iso: date.toISO(), daysInMonth: date.daysInMonth ?? 30 }
})

export const calculateMonthAndDayBySliderPosition = (rawSliderValue: number) => {
  let sliderValue = rawSliderValue
  // eslint-disable-next-line
  for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
    const { daysInMonth } = months[monthIndex]

    if (sliderValue <= daysInMonth!) {
      return { monthDate: DateTime.fromObject({ month: monthIndex + 1 }), dayNum: sliderValue }
    }

    sliderValue -= daysInMonth!
  }

  return { monthDate: DateTime.now(), dayNum: 1 }
}

const MAX_MEETINGS_DOTS = 10
export const getMonthMeetings = (monthNum: number, meetings: MeetingOverview[], year: number) => {
  // keeping only one unique status per day
  const map: Record<string, MeetingOverview> = meetings.reduce(
    (acc, i) => ({ ...acc, [`${DateTime.fromISO(i.date).toISODate()}_${i.status}`]: i }),
    {},
  )

  // month selection and sorting
  const list = Object.values(map)
    .filter(m => DateTime.fromISO(m.date).month === monthNum)
    .sort((a, b) => DateTime.fromISO(a.date).day - DateTime.fromISO(b.date).day) as Array<MeetingOverview>

  if (list.length >= MAX_MEETINGS_DOTS) {
    return list.slice(0, MAX_MEETINGS_DOTS)
  }

  const mockedArray = [
    { id: -1, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 1, year }) },
    { id: -2, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 4, year }) },
    { id: -3, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 7, year }) },
    { id: -4, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 10, year }) },
    { id: -5, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 13, year }) },
    { id: -6, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 16, year }) },
    { id: -7, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 19, year }) },
    { id: -8, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 22, year }) },
    { id: -9, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 25, year }) },
    { id: -10, status: 'x', date: DateTime.fromObject({ month: monthNum, day: 28, year }) },
  ]

  const finalMeetings = [...mockedArray].map(item => ({ ...item, date: String(item.date) }))
  const usedMeetings = new Set()

  // eslint-disable-next-line
  for (let i = 0; i < finalMeetings.length; i++) {
    const realMeeting = list.find(meeting => {
      // Skip this meeting if it has already been used
      if (usedMeetings.has(meeting.id)) return false

      const meetingDate = DateTime.fromISO(meeting.date)
      const currentMeetingDate = DateTime.fromISO(finalMeetings[i].date)
      const diffInDays = Math.abs(meetingDate.diff(currentMeetingDate, 'days').days)

      return diffInDays <= MAX_MEETINGS_DOTS
    })

    if (realMeeting) {
      finalMeetings[i] = realMeeting
      usedMeetings.add(realMeeting.id)
    }
  }

  return finalMeetings
}

export const fillYearsRange = (years: number[]): number[] => {
  const minYear = Math.min(...years)
  const maxYear = Math.max(...years)
  const yearRange = Array.from({ length: maxYear - minYear + 1 }, (_, i) => maxYear - i)

  return yearRange
}

export const isoDateEquals = (isoDate1: string, isoDate2: string) => {
  const date1 = DateTime.fromISO(isoDate1).toUTC()
  const date2 = DateTime.fromISO(isoDate2).toUTC()
  return date1.year === date2.year && date1.month === date2.month && date1.day === date2.day
}
